import { hotjar } from 'react-hotjar';

const hotjarId = Number(process.env.REACT_APP_HOTJAR_ID);
const hotjarTrackerVersion = process.env.REACT_APP_HOTJAR_TRACKER_VERSION;

if (hotjarId) hotjar.initialize(hotjarId, hotjarTrackerVersion);
